import { useEffect, useState } from "react";

import { AccordionState } from "./accordion";

type UseIsContentOverflowVisible = {
  internalState: AccordionState;
  delay: number;
};

export const useIsContentOverflowVisible = ({
  internalState,
  delay
}: UseIsContentOverflowVisible): boolean => {
  const [isOverflowVisible, setIsOverflowVisible] = useState(internalState === "open");

  useEffect(() => {
    let timeoutId;
    if (internalState === "open") {
      timeoutId = setTimeout(() => {
        setIsOverflowVisible(true);
      }, delay);
    } else {
      setIsOverflowVisible(false);
    }
    return () => clearTimeout(timeoutId);
  }, [internalState]);

  return isOverflowVisible;
};
